import { useState, useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { Menu, PanelLeftClose, PanelLeft } from 'lucide-react';
import ProfileCompletionBanner from '../ProfileCompletionBanner';

export const DashboardLayout = ({ children, title, actions }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    // Récupérer l'état depuis localStorage
    const saved = localStorage.getItem('sidebar_collapsed');
    return saved === 'true';
  });

  useEffect(() => {
    // Sauvegarder l'état dans localStorage
    localStorage.setItem('sidebar_collapsed', sidebarCollapsed);
  }, [sidebarCollapsed]);

  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
        collapsed={sidebarCollapsed}
      />
      
      {/* Main Content */}
      <div className={`transition-all duration-200 ${sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64'}`}>
        {/* Top Bar */}
        <header className="sticky top-0 z-20 bg-white border-b border-slate-200">
          <div className="flex items-center justify-between px-4 lg:px-8 h-16">
            <div className="flex items-center gap-4">
              {/* Mobile menu button */}
              <button
                onClick={() => setSidebarOpen(true)}
                className="lg:hidden p-2 rounded hover:bg-slate-100"
                data-testid="mobile-menu-btn"
              >
                <Menu className="w-5 h-5" />
              </button>
              
              {/* Desktop collapse button */}
              <button
                onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                className="hidden lg:flex p-2 rounded hover:bg-slate-100 text-slate-500 hover:text-slate-700"
                title={sidebarCollapsed ? "Afficher le menu" : "Réduire le menu"}
                data-testid="collapse-sidebar-btn"
              >
                {sidebarCollapsed ? (
                  <PanelLeft className="w-5 h-5" />
                ) : (
                  <PanelLeftClose className="w-5 h-5" />
                )}
              </button>
              
              <h1 className="text-xl font-bold text-slate-900 font-[Barlow]">{title}</h1>
            </div>
            {actions && <div className="flex items-center gap-3">{actions}</div>}
          </div>
        </header>

        {/* Page Content */}
        <main className="p-4 lg:p-8">
          {/* Profile completion nag — self-unmounts once profile_type is set */}
          <ProfileCompletionBanner />
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
